import moment = require("moment");
import momentTZ = require("moment-timezone");

const DTO_TIMESTAMP_FMT = "YYYY-MM-DD HH:mm:ss";
const DTO_DATE_FMT = "YYYY-MM-DD";

type DateLike = moment.MomentInput;

export function now() {
  return moment();
}

export function utcToday(): moment.Moment {
  return moment.utc();
}

export function isTimestamp(value: DateLike): boolean {
  return isMoment(value, DTO_TIMESTAMP_FMT);
}

export function toTimestamp(value: DateLike): moment.Moment {
  return moment(value, DTO_TIMESTAMP_FMT);
}

export function isDate(value: DateLike): boolean {
  return isMoment(value, DTO_DATE_FMT);
}

export function toDate(value: DateLike): moment.Moment {
  return moment(value, DTO_DATE_FMT);
}

export function momentToString(m: moment.Moment, onlyDate?: boolean): string {
  return onlyDate ? m.format(DTO_DATE_FMT) : m.format(DTO_TIMESTAMP_FMT);
}

export function isMoment(value: moment.MomentInput, format: string): boolean {
  const m = moment(value, format, true);
  return m.isValid();
}

export function getUserTimeZone() {
  return momentTZ.tz.guess();
}

export function getAllTimeZones() {
  return momentTZ.tz.names();
}
